import React from 'react';

const TooltipZIndexContext = React.createContext<undefined | number>(undefined);

export default TooltipZIndexContext;
